import Vue from 'vue'
import Vuex from 'vuex'
import entity from './entity/index'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
  modules: {
    entity
  },
  strict: debug,
  state: {
    // Busca si ya hay un valor guardado en localStorage, si no, por defecto false
    isDarkMode: localStorage.getItem('theme') === 'dark'
  },
  mutations: {
    TOGGLE_DARK_MODE(state) {
      state.isDarkMode = !state.isDarkMode;
      
      // Persistir la elección del usuario
      if (state.isDarkMode) {
        localStorage.setItem('theme', 'dark');
        document.documentElement.classList.add('dark-mode');
      } else {
        localStorage.setItem('theme', 'light');
        document.documentElement.classList.remove('dark-mode');
      }
    },
    // Mutación que se ejecuta al cargar la aplicación inicialmente
    INIT_THEME(state) {
      if (state.isDarkMode) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    }
    // ... tus otras mutaciones
  },
  actions: {
    toggleTheme({ commit }) {
      commit('TOGGLE_DARK_MODE');
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js